import { Pagination, SpliteButton } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { useNewNavigate, usePensionNameValue } from "@/shared/client";
import { FONT } from "@/styles";
import { Box, Button, chakra, Flex, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";
import { motion } from "framer-motion";
import { type SpecialType } from "../../specialPreview.type";

export const SpecialDetail = ({
    specials,
    currentIdx,
    nextSlide,
    prevSlide,
}: {
    nextSlide: () => void;
    prevSlide: () => void;
    currentIdx: number;
    specials: SpecialType[];
}) => {
    const { onNavigate } = useNewNavigate();
    const pensionName = usePensionNameValue();
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();
    return (
        <Flex maxW="720px" w="100%" h="100%">
            <Flex w="100%" flexDir="column" gap={isMobile ? "24px" : "56px"} p={isMobile ? "24px 16px 0 16px" : "0"}>
                <Flex flexDir="column" position="relative" p={isMobile ? "0" : "48px"} gap={isMobile ? "16PX" : "32px"}>
                    <Box
                        sx={{
                            "& p": {
                                color: "#664628",
                            },
                        }}
                    >
                        <Text {...FONT("notoSerif", isMobile ? 14 : 24, 400, 1.4)}>{pensionName}만의 특별함</Text>
                        <Text mt="8px" {...FONT("notoSerif", isMobile ? 20 : 40, 600, 1.4)}>
                            SPECIAL FACILITY
                        </Text>
                    </Box>
                    <Box position="relative" height={isMobile ? "136pX" : "256px"}>
                        {specials.map((special, index) => (
                            <MotionDetailBox
                                key={special.special_idx}
                                position="absolute"
                                h="inherit"
                                overflow="hidden"
                                initial={{ opacity: index === currentIdx ? 1 : 0 }}
                                animate={{
                                    opacity: index === currentIdx ? 1 : 0,
                                    transition: { duration: 0.7, ease: "easeIn" },
                                }}
                            >
                                <Text {...FONT("notoSerif", isMobile ? 16 : 20, 400, 1.4)}>
                                    {special.special_name.kor}
                                </Text>
                                <Text
                                    color="#6b6b6b"
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(special.content.kor.replace(/\r?\n/g, "<br />")),
                                    }}
                                    mt="16px"
                                    {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}
                                ></Text>
                            </MotionDetailBox>
                        ))}
                    </Box>
                    <Flex zIndex="99" justifyContent={isMobile ? "space-between" : "normal"}>
                        {isMobile && (
                            <Button
                                p="0 24px"
                                h="40px"
                                background="none"
                                border="1px solid #6b6b6b"
                                borderRadius="20px"
                                color="#6b6b6b"
                                {...FONT("notoSerif", 14, 400, 1.4)}
                                onClick={() => onNavigate({ path: `/specials/${specials[currentIdx].special_idx}` })}
                            >
                                MoreView
                            </Button>
                        )}
                        <Pagination
                            showPage={false}
                            currentPage={currentIdx}
                            totalPages={specials.length}
                            nextPage={nextSlide}
                            prevPage={prevSlide}
                            colorMode="black"
                        />
                    </Flex>
                </Flex>
                {!isMobile && (
                    <Flex w="100%" justifyContent="flex-end">
                        <SpliteButton
                            text="More View"
                            direction="reverse"
                            textBackGroundColor="#fbf6f2"
                            onClick={() => onNavigate({ path: `/specials/${specials[currentIdx].special_idx}` })}
                        />
                    </Flex>
                )}
            </Flex>
        </Flex>
    );
};

const MotionDetailBox = chakra(motion.div);
